import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Modal, Select } from "antd";
import useOtpHook from "../../../Hooks/useOtpHook";
import {
  addBenificiary2,
  addRecipient,
  getDmt3BankIfscCode,
  getDmt3Banks,
  verifyBankAccount,
  verifyBenificiary,
} from "../../../ApiServices/Apifun";
import {
  dispatchtoast,
  filterOption,
  getLocalStorageItem,
  ifscPattern,
} from "../../../Utils";
import CommonInput from "../../../Common/CommonInput";

const Add3BeneFiciaryModal = ({
  isOpen,
  setIsOpen,
  handleSearch,
  mobile,
  provider,
}) => {
  const formref = useRef();
  const [form] = Form.useForm();
  const [showOtpScreen, setShowOtpScreen] = useState(false);
  const [banks, setBanks] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [verifyBtnLoading, setVerifyBtnLoading] = useState(false);
  const [response, setResponse] = useState({});
  const [selectLoading, setselectLoading] = useState(false);
  const [ifsc, setIfsc] = useState();
  const [bankId, setBankId] = useState(null);
  const handleOk = () => {
    setIsOpen(false);
  };
  const { handleChange, handleKeyUp, pin, inputRefs } = useOtpHook(6);
  const handleCancel = () => {
    setIsOpen(false);
  };
  const getAllBanks = () => {
    setselectLoading(true);
    getDmt3Banks()
      .then((res) => {
        if (res.status) {
          setBanks(
            res.data?.bankInfoArray?.map((i, index) => {
              return {
                label: i.bankName,
                value: i.bankCode,
                // key: i?.ifsc_code ? i.ifsc_code : "",
              };
            }),
          );
          setselectLoading(false);
        } else {
          setBanks([]);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setselectLoading(false));
  };

  useEffect(() => {
    getAllBanks();
  }, []);

  const handleAdd = (val) => {
    let data = { ...val };
    data.BankCode = val.BankCode.value;
    console.log(val, "tttttt");
    setBtnLoading(true);
    const formdata = new FormData();
    formdata.append("senderMobileNumber", mobile);
    formdata.append("BankId", provider);
    Object.entries(data).forEach(([key, value]) => formdata.append(key, value));
    addRecipient(formdata)
      .then((res) => {
        if (res.status) {
          setIsOpen(false);
          setResponse(res.data);
          handleSearch();
          dispatchtoast("Remitter added successfully!");
        } else {
          setIsOpen(false);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setBtnLoading(false));
  };

  const handleVerifyBank = () => {
    setVerifyBtnLoading(true);
    const fieldValues = form.getFieldsValue();
    const formdata = new FormData();
    formdata.append("benificiary_account", fieldValues.BankAccountNumber);
    formdata.append("benificiary_ifsc", fieldValues.IFSC);
    formdata.append("benificiary_name", "abcd");
    formdata.append(
      "bank_id", bankId
    );
    formdata.append("latitude", getLocalStorageItem("latitude"));
    formdata.append("longitude", getLocalStorageItem("longitude"));
    verifyBankAccount(formdata)
      .then((res) => {
        if (res.status) {
          dispatchtoast(res.message);
          const beneficiaryName = res.data.beneficiary_name.replace(/^.*?\.\s*/, "");
          formref.current.setFieldsValue({
            RecipientName: beneficiaryName,
          });
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setVerifyBtnLoading(false));
  };
  const handlefillIFSC = (val) => {
    setselectLoading(true);
    setBankId(val.value);
    getDmt3BankIfscCode(val.value).then((res) => {
      if (res.status) {
        const ifscCode = res.data.masterIfscCode;

        setIfsc(ifscCode);

        formref.current?.setFieldsValue({
          IFSC: ifscCode,
        });
      } else {
        console.log(res.message);
      }
    }).catch((err) => console.log(err))
      .finally(() => setselectLoading(false));
  };
  return (
    <>
      <Modal
        title="Add Beneficiary"
        footer={null}
        className="shadow-normal flex justify-normal items-center"
        width={300}
        maskClosable={false}
        open={isOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Form
          name="basic"
          form={form}
          ref={formref}
          initialValues={{
            remember: true,
          }}
          onFinishFailed={(err) => console.log(err)}
          onFinish={(val) => handleAdd(val)}
        >
          <Form.Item
            name={`BankAccountNumber`}
            label={"Account Number"}
            labelCol={{ span: 24 }}
            rules={[
              {
                required: true,
                message: "Fill Account Number!",
              },
            ]}
          >
            <CommonInput
              onInput={(e) => {
                const value = e.target.value.replace(/\D/g, "");
                e.target.value = value;
              }}
              placeholder="Enter Account Number"
            />
          </Form.Item>{" "}
          <Form.Item
            name={`BankCode`}
            label={"Select Bank"}
            labelCol={{ span: 24 }}
            rules={[
              {
                required: true,
                message: "Select any one bank!",
              },
            ]}
          >
            <Select
              placeholder="Select Bank"
              loading={selectLoading}
              filterOption={filterOption}
              showSearch={true}
              labelInValue
              onChange={(val) => handlefillIFSC(val)}
              className="w-full"
              options={banks}
            />
          </Form.Item>{" "}
          <div className="grid grid-cols-3 place-items-center gap-2 m-2">
            <Form.Item
              name={`IFSC`}
              label={"IFSC"}
              className="col-span-2"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter IFSC Code!",
                },
                {
                  pattern: ifscPattern,
                  message: "Invalid ifsc number format!",
                },
              ]}
            >
              <CommonInput
                onInput={(e) => {
                  e.target.value = e.target.value.toUpperCase();
                }}
                placeholder="Enter IFSC Code"
              />
            </Form.Item>{" "}
            <Button
              loading={verifyBtnLoading}
              onClick={() => handleVerifyBank()}
              className="bg-primary mt-4 p-3 w-full text-xs flex justify-center items-center outline-none border-none  text-white  rounded-md"
            >
              Verify Bank
            </Button>
          </div>
          <Form.Item
            name={`RecipientName`}
            label={"Account Holder Name"}
            labelCol={{ span: 24 }}
            rules={[
              {
                required: true,
                message: "Enter account holder name!",
              },
            ]}
          >
            <CommonInput placeholder="Enter account holder name" />
          </Form.Item>{" "}
          <Form.Item
            name={`RecipientMobileNumber`}
            label={"Mobile Number"}
            labelCol={{ span: 24 }}
            rules={[
              {
                required: true,
                message: "Enter mobile!",
              },
            ]}
          >
            <CommonInput placeholder="Enter mobile" />
          </Form.Item>{" "}
          <Form.Item
            className="w-full"
          //   wrapperCol={{
          //     offset: 8,
          //     span: 16,
          //   }}
          >
            <Button
              htmlType="submit"
              loading={btnLoading}
              className="bg-primary p-3 w-full flex justify-center items-center outline-none border-none  text-white  rounded-md"
            >
              Add{" "}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default Add3BeneFiciaryModal;